import React, {FC, useState} from 'react';
import TermsImportedTable from './terms-imported-table';
import {Term} from "~/types/term-type.ts";
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";

export const TermsImported: FC = () => {
    const [includeInactiveTerms, setIncludeInactiveTerms] = useState(false);
    const activeTerms: Term[] = useSelector(Selectors.getActiveTerms);
    const inactiveTerms: Term[] = useSelector(Selectors.getInactiveTerms);

    const allTerms: { active: Term[], inactive: Term[] } = {
        active: activeTerms,
        inactive: inactiveTerms
    }

    const visibleTerms = includeInactiveTerms
        ? allTerms.active.concat(allTerms.inactive)
        : allTerms.active;

    const onClickIncludeActive = () => {
        setIncludeInactiveTerms(prevState => !prevState);
    };

    return (
        <React.Fragment>

            <div className="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    id="includeInactive"
                    className="custom-control-input"
                    checked={includeInactiveTerms}
                    onChange={onClickIncludeActive}
                />
                <label className="custom-control-label" htmlFor="includeInactive">Include inactive terms</label>
            </div>

            <TermsImportedTable visibleTerms={visibleTerms} allTerms={allTerms}/>
        </React.Fragment>
    );
}

export default TermsImported;
